"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _getRandomArbitrary = _interopRequireDefault(require("./getRandomArbitrary"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Method
// ----------------------------------------------------------------------------

/** returns a random int between min (inclusive) and max (exclusive) */


var getRandomArbitraryInt = function getRandomArbitraryInt(min, max) {
  return Math.round((0, _getRandomArbitrary["default"])(min, max));
}; // ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Exports
// ----------------------------------------------------------------------------


var _default = getRandomArbitraryInt;
exports["default"] = _default;
module.exports = exports.default;